import script from "./RoleTag.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleTag.vue?vue&type=script&setup=true&lang=js"

import "./RoleTag.vue?vue&type=style&index=0&id=1440f00b&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1440f00b"]])

export default __exports__